import React from 'react';

type MainContainerProps = {
  children: React.ReactNode;
};

const MainContainer = ({children}: MainContainerProps) => (
  <div className="w-5/6 bg-aliceblue rounded-gigantic my-6 mr-6 p-10 flex flex-col">
    {children}
  </div>
);

export default MainContainer;
